import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'

// Simple Modal Wrapper for createPortal
// inspired by https://reactjs.org/docs/portals.html

const modalRoot = document.getElementById('modal-root');

const Modal = (props) => {
  const el = document.createElement('div');

  useEffect(() => {
    modalRoot.appendChild(el);
    return () => modalRoot.removeChild(el);
  }, []);

  return ReactDOM.createPortal(props.children, el);
}

export default Modal;
